module.exports = {"510184001":"崇阳街道","510184101":"三江镇","510184102":"江源镇","510184103":"羊马镇","510184104":"廖家镇","510184105":"元通镇","510184106":"观胜镇","510184107":"怀远镇","510184108":"三郎镇","510184109":"街子镇","510184110":"文井江镇","510184111":"王场镇","510184112":"白头镇","510184113":"道明镇","510184114":"隆兴镇","510184116":"大划镇","510184117":"崇平镇","510184118":"梓潼镇","510184119":"桤泉镇","510184201":"锦江乡","510184202":"公议乡","510184206":"鸡冠山乡","510184208":"济协乡","510184209":"燎原乡","510184211":"集贤乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510184.json
// module id = 2093
// module chunks = 0